import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';
import { atomWithSessionStorage } from '@/common/atoms/atomEffects';
import type { TeamSearchFields } from '../PartnerMap/types';

export type Location = {
  id: string;
  label: string;
  secondaryLabel?: string;
  latitude?: number;
  longitude?: number;
  mailingAddress?: TeamSearchFields['mailingAddress'];
} | null;

export type LocationWithCoordinates = NonNullable<Location> & {
  latitude: number;
  longitude: number;
};

export type CommunityListingsFilters = {
  distance?: {
    radius: string;
    location: LocationWithCoordinates;
  } | null;
  showOnlySideExclusiveListings: boolean;
  showOnlyMyListings: boolean;
  hideOnlyMyListings: boolean;
};

export const appliedFilters = atomWithSessionStorage<CommunityListingsFilters>(
  'communityListingsAppliedFilters',
  {
    distance: null,
    showOnlySideExclusiveListings: false,
    showOnlyMyListings: false,
    hideOnlyMyListings: false,
  },
);

export const numAppliedFilters = atom((get) => {
  return Object.values(get(appliedFilters)).filter((val) => !!val).length;
});

export const isFilterApplied = atomFamily(
  (key: keyof CommunityListingsFilters) =>
    atom((get) => {
      return !!get(appliedFilters)[key];
    }),
);
